import { NavigationMode } from '@app/common/navigation-mode.';
import { CafcassEnvironment } from './cafcassEnvironment';
import { NewsModeFeaturedNews, NewsModePersonalNews } from '@app/common/news-mode';
import { ManagedProperties } from '@app/common/managed-property-config';
import { TrendingResult } from '@app/common/trending-result';
import { AuthorizationMode } from '@app/common/authorization-mode';
import { DefaultProtectedResourceScopesMap } from '@app/common/msal-angular-configuration';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// Booldev CoreIntranet
export const environment: CafcassEnvironment = {
  production: true,
  name: 'prod',
  tenantHostUrl: 'https://cafcass.sharepoint.com',
  coreWorkplaceSiteUrl: 'https://cafcass.sharepoint.com/sites/Workplace',
  msalConfig: {
    tenant: 'cafcass.onmicrosoft.com',
    auth: {
      clientId: 'e0fcad00-54ac-4f1f-b56b-4884c13ffa4e',
      authority: 'https://login.microsoftonline.com/cafcass.onmicrosoft.com',
    },
    protectedResourceScopeMap: [
      ...DefaultProtectedResourceScopesMap,
      [`/api/`, [`e0fcad00-54ac-4f1f-b56b-4884c13ffa4e/.default`]],
      ['https://cafcass.sharepoint.com', ['https://cafcass.sharepoint.com/.default']],
    ],
    useRedirect : true
  },
  authorizationMode: AuthorizationMode.Claims,
  blogSiteUrl: 'https://cafcass.sharepoint.com/sites/blogs', // The URL to Cafcass blog site.
  complimentsWallSiteUrl: 'https://cafcass.sharepoint.com/sites/compliments', // The URL to Cafcass Compliments Wall site.
  featureSettings: {
    workplaceName: 'Cafcass',
    gaTrackingKey: '',
    appInsightsTrackingKey: '7f599e04-d992-4fce-8acb-caab2bc54716',
    navigationMode: NavigationMode.HubSite,
    newsCenterSiteUrl: 'https://cafcass.sharepoint.com/sites/News',
    newsModeFeaturedNews: NewsModeFeaturedNews.GraphFromNewsCenterSite,
    newsModePersonalNews: NewsModePersonalNews.GraphFromNewsCenterSite,
    excludeSitesFromNewsSearch: ['https://cafcass.sharepoint.com/sites/blogs', 'https://cafcass.sharepoint.com/sites/compliments'],
    showDescriptionInSearchResult: true,
    trendingResult: TrendingResult.Modern,
    newsArchiveLink: '',
    sharePointNewsCenterUrl: 'https://cafcass.sharepoint.com/sites/News',
    showNewOrModifiedbadgeOnAppTile: true,
    managedPropertyConfig: ManagedProperties.DefaultConfig,
    redirectToTeamsByDefault: true,
    enableRequiredReading: true,
    prefixToO365Groups: '',
    myColleagueRootTerm: 'd98acfac-21d2-4957-8f38-22d178dc8ec4',
    myColleaguesShowOrgChart: true,
    enableRightSection: true,
    allowMarkAsReadFromReqReadList: true,
    chartsBackground: ['#cc2e64', '#0C7191', '#C7DAEA', '#b300b3', '#ff6666', '#ff9933', '#3366ff', '#80ff00', '#3366ff', '#ffbb33'],
    colleagueProperties: {
      Property1: {
        Label: 'Job Title',
        Name: 'jobTitle'
      },
      Property2: {
        Label: 'City',
        Name: 'City'
      }
    },
    showBirthdayCalendar: true,
    showRestaurantMenus: true,
    useGraphToExtendPeopleSearch: true,
    customSearchResult: {
      Title: 'Offices',
      Query: 'AND SiteName:https://cafcass.sharepoint.com/sites/offices AND contentclass:STS_List AND ((ContentTypeId:0x0101009D1CB255DA76424F860D91F20E6C4118* AND PromotedState:0) OR (ContentTypeId:0x010100C568DB52D9D0A14D9B2FDCC96666E9F2007948130EC3DB064584E219954237AF39*))',
      SelectProperties: ['Title', 'Path', 'SiteTitle', 'Description', 'LastModifiedTime'],
      ResultIcon: 'ms-Icon ms-Icon--CityNext'
    },
    myDetailsMsGraphProperties: [
      'id',
      'displayName',
      'mail',
      'assignedPlans',
      'assignedLicenses',
      'city',
      'country',
      'jobTitle',
      'state',
      'department',
      'companyName',
      'officeLocation',
      'userPrincipalName',
      'mobilePhone',
      'extension_bb58b85a3e724127a95e0a4bd0d557b8_extensionAttribute13'
    ],
    myColleagueNumberOfGraphResultsCap: 60,
    enableIosA2hsBanner: true,
    showPowerBIComponent: true,
    disableLocalStorage: true,
    requireChannelSelectionForPowerBIVisuals: true,
    calendarPageInfoUrl: 'https://cafcass.sharepoint.com/sites/diversity/SitePages/Equality,-diversity-and-inclusion-calendar.aspx',
  },
};
